export default __webpack_public_path__ + "static/media/icon-file-doc-empty.d8f8c333.svg";